import React, { Component } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { sendError } from "config/paths";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.token = props.token;
    this.user = props.user;
    this.wrapper = props.wrapper || (props => <div {...props} />);
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (this.user) {
      fetch(sendError(this.token), {
        method: "POST",
        body: JSON.stringify({
          error: error.toString(),
          errorInfo: errorInfo.componentStack.toString(),
        }),
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${this.token}`,
        },
        mode: "cors",
      });
    }
  }

  render() {
    const Wrapper = this.wrapper;

    if (this.state.hasError) {
      console.error(this.state.hasError);
      return (
        <Wrapper>
          <h1>
            <FormattedMessage id="common.error" />
          </h1>
        </Wrapper>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  /**
   * Token actual
   */
  token: PropTypes.string,
  /**
   * Usuario actual
   */
  user: PropTypes.object,
  /**
   * Componente en el que se enmarca el error, por defecto Dashboard
   */
  wrapper: PropTypes.func,
};

export default ErrorBoundary;
